import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { motion } from 'motion/react';
import type { RootState } from '@/app/store.js';
import { LoadingSpinner } from '@/components/common/LoadingSpinner/LoadingSpinner.js';

export interface ProtectedRouteProps {
  children: React.ReactNode;
  /**
   * Optional loading flag. If true, renders spinner instead of redirecting.
   * Useful when an outer auth-init is still in progress.
   */
  isCheckingAuth?: boolean;
}

export function ProtectedRoute({ children, isCheckingAuth }: ProtectedRouteProps) {
  const isAuthenticated = useSelector((s: RootState) => s.auth.isAuthenticated);
  const location = useLocation();

  if (isCheckingAuth) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2 }}
        className="grid min-h-screen w-full place-items-center"
      >
        <LoadingSpinner size="lg" message="Проверяем авторизацию..." />
      </motion.div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
